import { API_URL, jwtToken } from "../../../context/appContext";
export default async function createAccumulators(orders) {
    return fetch(`${API_URL}/api/accumulator_process`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(orders)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
